
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/withdraw",
    icon: "key",
    title: "提现审核",
    component: Main,
    children: [
      {
        path: "audit",
        title: "提现审核",
        name: "WithdrawAudit",
        component: resolve => {
          require(["@/views/seller/withdraw/audit.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/seller",
    icon: "android-menu",
    title: "个人卖家",
    component: Main,
    children: [
      {
        path: "settle",
        title: "入驻信息查看/审核",
        name: "SellerSettle",
        component: resolve => {
          require(["@/views/seller/settle.vue"], resolve);
        }
      },
      {
        path: "self-settle",
        title: "入驻信息审核",
        name: "SelfSellerSettle",
        component: resolve => {
          require(["@/views/seller/self-settle.vue"], resolve);
        }
      },
      {
        path: "upload",
        title: "个人卖家店铺对应表",
        name: "SellerUpload",
        component: resolve => {
          require(["@/views/seller/upload.vue"], resolve);
        }
      },
      {
        path: "spuImport",
        title: "个人卖家SPU导入",
        name: "SellerSPUImport",
        component: resolve => {
          require(["@/views/seller/spu-import.vue"], resolve);
        }
      },
      {
        path: "goodsPool",
        title: "个人卖家商品池",
        name: "SellerGoodsPool",
        component: resolve => {
          require(["@/views/seller/goods-pool.vue"], resolve);
        }
      },
      {
        path: "bulletin",
        title: "公告列表",
        name: "SellerBulletin",
        component: resolve => {
          require(["@/views/seller/bulletin.vue"], resolve);
        }
      },
      {
        path: "rules",
        title: "规则中心",
        name: "SellerRules",
        component: resolve => {
          require(["@/views/seller/rules.vue"], resolve);
        }
      },
      {
        path: "rules/add",
        title: "新增规则公告",
        name: "SellerRulesAdd",
        component: resolve => {
          require(["@/views/seller/rules-form.vue"], resolve);
        }
      },
      {
        path: "rules/edit/:id",
        title: "规则公告编辑",
        name: "SellerRulesEdit",
        component: resolve => {
          require(["@/views/seller/rules-form.vue"], resolve);
        }
      },
      {
        path: "rules/show/:sid",
        title: "查看规则公告",
        name: "SellerRulesShow",
        component: resolve => {
          require(["@/views/seller/rules-form.vue"], resolve);
        }
      },
      {
        path: "bulletin/add",
        title: "新增公告",
        name: "SellerBulletinAdd",
        component: resolve => {
          require(["@/views/seller/bulletin-form.vue"], resolve);
        }
      },
      {
        path: "bulletin/edit/:id",
        title: "公告编辑",
        name: "SellerBulletinEdit",
        component: resolve => {
          require(["@/views/seller/bulletin-form.vue"], resolve);
        }
      },
      {
        path: "bulletin/show/:sid",
        title: "查看公告",
        name: "SellerBulletinShow",
        component: resolve => {
          require(["@/views/seller/bulletin-form.vue"], resolve);
        }
      },
      {
        path: "serviceFee",
        title: "指定spu手续费",
        name: "SellerServiceFee",
        component: resolve => {
          require(["@/views/seller/serviceFee.vue"], resolve);
        }
      },
      {
        path: "feeReduction",
        title: "指定用户转账手续费限免",
        name: "SellerServiceFee",
        component: resolve => {
          require(["@/views/seller/fee-reduction.vue"], resolve);
        }
      },
      {
        path: "alert",
        title: "指定spu弹窗",
        name: "SellerAlert",
        component: resolve => {
          require(["@/views/seller/alert.vue"], resolve);
        }
      },
      {
        path: "feedback",
        title: "意见反馈",
        name: "SellerFeedback",
        component: resolve => {
          require(["@/views/seller/feedback.vue"], resolve);
        }
      },
      {
        path: "account",
        title: "用户列表",
        name: "SellerAccount",
        component: resolve => {
          require(["@/views/seller/account.vue"], resolve);
        }
      },
      {
        path: "qc-standards",
        title: "品牌质检标准图",
        name: "SellerQCStandards",
        component: resolve => {
          require(["@/views/seller/qc-standards.vue"], resolve);
        }
      },
      {
        path: "promotion/serviceFee",
        title: "活动",
        name: "SellerPromotionServiceFee",
        component: resolve => {
          require(["@/views/seller/promotion/serviceFee.vue"], resolve);
        },
      },
      {
        path: "promotion/serviceFee/create",
        title: "创建活动",
        name: "SellerPromotionServiceFeeCreate",
        component: resolve => {
          require(["@/views/seller/promotion/serviceFeeForm.vue"], resolve);
        },
      },
      {
        path: "promotion/serviceFee/edit/:id",
        title: "编辑活动",
        name: "SellerPromotionServiceFeeEdit",
        component: resolve => {
          require(["@/views/seller/promotion/serviceFeeForm.vue"], resolve);
        },
      },
      {
        path: "campaignPopover",
        title: "弹窗",
        name: "SellerCampaignPopover",
        component: resolve => {
          require(["@/views/seller/campaignPopover.vue"], resolve);
        },
      },
      {
        path: "poll",
        title: "问卷",
        name: "SellerPoll",
        component: resolve => {
          require(["@/views/seller/poll.vue"], resolve);
        },
      },
      {
        path: "noReasonReturn",
        title: "无理由退货配置",
        name: "SellerNoReasonReturn",
        component: resolve => {
          require(["@/views/seller/noReasonReturn/index.vue"], resolve);
        },
      },
    ]
  },
]

export default customerRoutes
